const groupPrefixRoles = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.ROLES)
const groupPrefixPerms = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.PERMISSIONS)

export const apiRolesPermissions = {
	fetchEmployeeRoles: async () => {
		const { data } = await apiCommon<IEmployeeRole[]>(`${groupPrefixRoles}`, {
			method: 'GET',
		})
		if (!data) return []
		return data.map(d => EmployeeRole(d))
	},

	fetchEmployeePermissions: async () => {
		const { data } = await apiCommon<IEmployeePermissions>(`${groupPrefixPerms}`, {
			method: 'GET',
		})
		return EmployeePermission(data)
	},

	saveEmployeePermissions: async (permissionData: any) => {
		const { data } = await apiCommon<IEmployee>(`${groupPrefixPerms}`, {
			method: 'POST',
			body: { data: permissionData },
		})
		return EmployeePermission(data)
	},

	createEmployeeRole: async (name: string) => {
		const { data } = await apiCommon<IEmployeeRole>(`${groupPrefixRoles}`, {
			method: 'POST',
			body: { name },
		})
		return EmployeeRole(data)
	},

	saveEmployeeRoleRanks: async (ranks: IEmployeeRanks) => {
		const { data } = await apiCommon<IEmployeeRanks>(`${groupPrefixRoles}/associations`, {
			method: 'POST',
			body: { data: ranks },
		})
		return EmployeePermission(data)
	},

	editEmployeeRole: async (roleID: number, name: string) => {
		const { data } = await apiCommon<IEmployeeRole>(`${groupPrefixRoles}/${roleID}`, {
			method: 'PUT',
			body: { name },
		})
		return EmployeeRole(data)
	},
}
